import { createFileRoute } from '@tanstack/react-router'
import WorkCorrectionSection from 'Work/components/Work/Sections/Corrections/WorkCorrectionSection'

export const Route = createFileRoute('/work/$workId/corrections')({
    component: WorkCorrectionSection,
})
